import { EyeOutlined, PlusOutlined, DownloadOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import { DsBaoHiemPagingResponse } from '@app/models/baohiem/BaoHiem';
import { XuatExcelBaoCao, layDsBaoHiem, xoaBaoHiemThang } from '@app/services/baohiem';
import { Col, Row, Space, Table, Button, DatePicker, DatePickerProps, Select } from 'antd';
import Column from 'antd/es/table/Column';
import { Tag } from 'antd/lib';
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { searchLength } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, formatVND } from '../../helpers/common';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import dayjs, { Dayjs } from 'dayjs';

const DanhSachBaoHiem = () => {
    const [nam, setNam] = useState<number>(new Date().getFullYear());
    const [namValue, setNamValue] = useState<Dayjs | null>(dayjs());
    const [loaiBaoHiem, setLoaiBaoHiem] = useState<number | null>(null);
    const [trangThai, setTrangThai] = useState<number | null>(null);
    const namFormat: DatePickerProps['format'] = (value) => value.format('YYYY');
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const menu: any = menuHelper.checkMultiPermission([Links.BaoHiem.Them, Links.BaoHiem.Xem]);
    const [danhsach, setDanhSach] = useState<DsBaoHiemPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });
    const dispatch = useDispatch();

    // --- Xóa ---
    const [showModalXoa, setShowModalXoa] = useState(false);
    const [idXoa, setIdXoa] = useState<number>(0);

    // --- Tải Excel ---
    const [idTai, setIdTai] = useState<number>(0);

    const onChangeNam: DatePickerProps['onChange'] = (year) => {
        setNamValue(year);
        setNam(year ? parseInt(year.format('YYYY')) : new Date().getFullYear());
    };

    const timkiem = async (start: number, length: number, page: number, namSearch?: number | null, loaiSearch?: number | null, trangThaiSearch?: number | null) => {
        try {
            dispatch(showLoadingScreen());
            const searchNam = namSearch !== undefined ? namSearch : nam;
            const searchLoai = loaiSearch !== undefined ? loaiSearch : loaiBaoHiem;
            const searchTrangThai = trangThaiSearch !== undefined ? trangThaiSearch : trangThai;
            const temp = await layDsBaoHiem(start, length || searchLength, searchNam, searchLoai, searchTrangThai);
            temp.data.forEach((item: any) => {
                item.thangNam = 'Tháng ' + dateCommon.formatDate(item.thangNam).slice(3).toString();
                item.tongTien = formatVND(item?.tongTien);
            });
            const maxPage = temp?.recordsTotal === 0 ? 0 : (parseInt((temp?.recordsTotal / searchLength).toString()) + (temp?.recordsTotal % searchLength ? 0 : -1)) || 0;
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => { item.key = item.id; return item }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": maxPage,
                "pageCurrent": page,
                "pageListShow": []
            });
            dispatch(hideLoadingScreen());
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
        };
    };

    const handleTimKiem = () => {
        timkiem(0, searchLength, 0, nam, loaiBaoHiem, trangThai);
    };

    // Mở modal confirm xóa
    const handleClickXoa = (id: number) => {
        setIdXoa(id);
        setShowModalXoa(true);
    };

    // Thực hiện xóa sau khi xác nhận
    const handleXacNhanXoa = async () => {
        setShowModalXoa(false);
        try {
            dispatch(showLoadingScreen());
            await xoaBaoHiemThang(idXoa);
            toast.success("Xóa bảo hiểm thành công");
            timkiem(0, searchLength, 0, nam, loaiBaoHiem, trangThai);
        } catch (err: any) {
            toast.error(err?.message || "Xóa bảo hiểm thất bại. Vui lòng thử lại");
            dispatch(hideLoadingScreen());
        }
    };

    // Xuất Excel
    const handleTaiExcel = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            const response = await XuatExcelBaoCao(id);
            const link = document.createElement('a');
            link.download = `BaoHiemXaHoi.xlsx`;
            const blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex) {
            toast.error("Xuất báo cáo không thành công. Vui lòng thử lại");
        }
        dispatch(hideLoadingScreen());
    };

    useEffect(() => {
        timkiem(0, searchLength, 0, nam, loaiBaoHiem, trangThai);
    }, [nam, loaiBaoHiem, trangThai]);

    useEffect(() => {
        if (reloadPage) {
            setReloadPage(false);
        }
    }, [reloadPage]);

    return (<section>
        <ContentHeader title="Quản lý Bảo hiểm" />

        <div className="card card-primary" style={{ padding: '12px 16px', marginBottom: '16px' }}>
            <Row gutter={[12, 8]} align="middle">
                <Col span="20">
                    <Space>
                        <span style={{ fontWeight: 600, marginRight: "15px" }}>Năm:</span>
                        <DatePicker
                            changeOnBlur={true}
                            value={namValue}
                            style={{ width: 200 }}
                            placeholder="Chọn năm"
                            picker="year"
                            format={namFormat}
                            onChange={onChangeNam}
                            allowClear={false}
                        />
                        <span style={{ fontWeight: 600, marginRight: "15px", marginLeft: "20px" }}>Loại BHXH:</span>
                        <Select
                            style={{ width: 180 }}
                            placeholder="-- Tất cả --"
                            allowClear
                            value={loaiBaoHiem}
                            onChange={(value) => setLoaiBaoHiem(value ?? null)}
                        >
                            <Select.Option value={0}>Bảo hiểm tháng</Select.Option>
                            <Select.Option value={1}>Bổ sung, điều chỉnh</Select.Option>
                        </Select>
                        <span style={{ fontWeight: 600, marginRight: "15px", marginLeft: "20px" }}>Trạng thái:</span>
                        <Select
                            style={{ width: 200 }}
                            placeholder="-- Tất cả --"
                            allowClear
                            value={trangThai}
                            onChange={(value) => setTrangThai(value ?? null)}
                        >
                            <Select.Option value={0}>Khởi tạo</Select.Option>
                            <Select.Option value={1}>Đã xác nhận</Select.Option>
                        </Select>
                    </Space>
                </Col>
                {menu[Links.BaoHiem.Them] && (
                    <Col flex="auto" style={{ textAlign: 'right' }}>
                        <Link to={Links.BaoHiem.Them} className="hrm-btn hrm-btn-warning">
                            <PlusOutlined className='align-self-center' rev="" />Thêm mới
                        </Link>
                    </Col>
                )}
            </Row>
        </div>

        <div className="card card-primary">
            <Row>
                <Col span={24}>
                    <Table
                        locale={{ emptyText: "Không có dữ liệu" }}
                        dataSource={danhsach?.data}
                    >
                        <Column title="Kỳ BHXH" dataIndex={"thangNam"} key="thangNam" />
                        <Column title="Loại BHXH" key="loaiBaoHiemThang" dataIndex="loaiBaoHiemThang" render={(value) => {
                            if (value === 0) {
                                return (<Tag color="success">Bảo hiểm tháng</Tag>);
                            }
                            return (<Tag color="processing">Bổ sung, điều chỉnh</Tag>);
                        }} />
                        <Column
                            title="Tổng số LĐ"
                            align="center"
                            key="tongSoLD"
                            render={(_, record) => (
                                (record?.slNguoiQuanLy || 0) + (record?.slNguoiLaoDong || 0)
                            )}
                        />
                        <Column title="Người Quản Lý" align="center" dataIndex="slNguoiQuanLy" key="slNguoiQuanLy" />
                        <Column title="Người Lao Động" align="center" dataIndex="slNguoiLaoDong" key="slNguoiLaoDong" />
                        <Column title="Tổng số phát sinh" dataIndex="tongTien" key="tongTien" />
                        <Column
                            title="Trạng thái"
                            key="trangThai"
                            align="center"
                            render={(value: any) => (
                                value.trangThai == 0 ? (<Tag color="blue">Khởi tạo</Tag>) : (<Tag color="success">Đã xác nhận</Tag>)
                            )}
                        />
                        <Column
                            width="220px"
                            title="Hành động"
                            key="action"
                            render={(value, record: any, index) =>
                            (
                                <Space>
                                    <Link key={"link" + index} className="hrm-btn btn-primary" to={`${Links.BaoHiem.Xem}?id=${value?.id}`}>
                                        <EyeOutlined className='align-self-center' />Xem
                                    </Link>
                                    <Button
                                        className="hrm-btn hrm-btn-success"
                                        icon={<DownloadOutlined rev="" />}
                                        onClick={() => handleTaiExcel(value?.id)}
                                    >
                                        Tải
                                    </Button>
                                    {record.trangThai == 0 &&
                                        <Button
                                            className="hrm-btn-delete"
                                            icon={<DeleteOutlined rev="" />}
                                            onClick={() => handleClickXoa(value?.id)}
                                        >
                                            Xóa
                                        </Button>}
                                </Space>
                            )
                            }
                        />
                    </Table>
                </Col>
            </Row>
        </div>

        <ModalTextForm
            show={showModalXoa}
            title="Xóa bảo hiểm"
            handleClose={() => setShowModalXoa(false)}
            handleSave={handleXacNhanXoa}
        >
            Bạn có chắc chắn muốn xóa thông tin kỳ BHXH này không?
        </ModalTextForm>
    </section>
    );
};

export default DanhSachBaoHiem;
